const get = (env) => {
  const internal = require(`./internal/${env}.json`);
  const external = require(`./external/${env}.json`);
  let data = {};
  data.url = Object.assign({}, internal.url, external.url);
  data.url.api = Object.assign({}, internal.url.api || {}, external.url.api || {});

  return data;
};

module.exports = {
  development: get('development'),
  production: get('production'),
  homolog: get('homolog'),
  test: get('test'),
  sandbox: get('sandbox')
};
